import type { NavigateFunction } from 'react-router';
import {
  type DappRouteDapp,
  getDappHomePath as getCanonicalDappHomePath,
  getDappReleasePath as getCanonicalDappReleasePath,
} from '../../../utils/dappRoutes';

type ReleaseRouteTarget = DappRouteDapp | undefined;

export function getDappHomePath(dapp: ReleaseRouteTarget) {
  return dapp ? getCanonicalDappHomePath(dapp) : '/dashboard';
}

function getReleasePath(dapp: ReleaseRouteTarget, releaseId: string) {
  return dapp
    ? getCanonicalDappReleasePath(dapp, releaseId)
    : `/dashboard/releases/${releaseId}`;
}

export function scheduleReleaseNavigation(
  navigate: NavigateFunction,
  dapp: ReleaseRouteTarget,
  releaseId: string,
  delayMs = 2000,
) {
  window.setTimeout(() => {
    navigate(getReleasePath(dapp, releaseId));
  }, delayMs);
}
